<template>
  <div class="activitati-container">
    <!-- Dashboard Section -->
    <div class="metrics-section activitati-dashboard">
      <div class="metric-card clickable-card" :class="{ 'active-filter': activeDashboardFilter === 'total' }"
        @click="filterDashboard('total')">
        <div class="metric-icon" style="background: #e0e7ff;">
          <i class="dx-icon-task" style="color: #3730a3;"></i>
        </div>
        <div class="metric-content">
          <div class="metric-label">Toate Activitățile</div>
          <div class="metric-value">{{ dashboardStats.total }}</div>
        </div>
      </div>

      <div class="metric-card clickable-card" :class="{ 'active-filter': activeDashboardFilter === 'overdue' }"
        @click="filterDashboard('overdue')">
        <div class="metric-icon" style="background: #fecaca;">
          <i class="dx-icon-warning" style="color: #991b1b;"></i>
        </div>
        <div class="metric-content">
          <div class="metric-label">Activități Depășite</div>
          <div class="metric-value overdue-text">{{ dashboardStats.overdue }}</div>
        </div>
      </div>

      <div class="metric-card clickable-card" :class="{ 'active-filter': activeDashboardFilter === 'today' }"
        @click="filterDashboard('today')">
        <div class="metric-icon" style="background: #dbeafe;">
          <i class="dx-icon-event" style="color: #1e40af;"></i>
        </div>
        <div class="metric-content">
          <div class="metric-label">De Făcut Astăzi</div>
          <div class="metric-value">{{ dashboardStats.today }}</div>
        </div>
      </div>

      <div class="metric-card clickable-card" :class="{ 'active-filter': activeDashboardFilter === 'upcoming' }"
        @click="filterDashboard('upcoming')">
        <div class="metric-icon" style="background: #fef3c7;">
          <i class="dx-icon-clock" style="color: #78350f;"></i>
        </div>
        <div class="metric-content">
          <div class="metric-label">Activități Următoare</div>
          <div class="metric-value">{{ dashboardStats.upcoming }}</div>
        </div>
      </div>
    </div>

    <!-- Grid Section -->
    <div class="grid-wrapper">
      <DxDataGrid ref="dataGrid" :allowColumnReordering="true" :data-source="dsActivitati" :allowColumnResizing="true"
        key-expr="ID" :columnAutoWidth="false" :columnResizingMode="'nextColumn'" :show-borders="true"
        :syncLookupFilterValues="false" :filter-sync-enabled="true" :show-column-lines="false" :allowMerging="'Cells'"
        height="100%" class="grid theme-dependent" @exporting="onExporting" :hover-state-enabled="true"
        :filter-value="dateFilterValue" @content-ready="onGridContentReady" @editing-start="onEditingStart"
        @row-removing="onRowRemoving" @row-removed="onRowRemoved">
        <DxSelection mode="single" />
        <DxColumnChooser :enabled="true" :allow-search="true" title="Selector coloane" />
        <DxPaging :page-size='15' :page-index='1' />
        <DxSorting mode="multiple" />
        <DxHeaderFilter :visible="false" />
        <DxFilterRow :visible="true" />
        <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
        <DxSearchPanel :visible="true" placeholder="Cauta Activitatea" :search-visible-columns-only="true" />
        <DxExport :enabled="true" :allow-export-selected-data="true" :formats="['xlsx', 'pdf']" />
        <DxGridToolbar>

          <DxGridToolbarItem location="after" locate-in-menu="auto">
            <div>
              <dx-button icon="plus" type="success" @click="onAddClick" />
            </div>
          </DxGridToolbarItem>
          <DxGridToolbarItem location="after" locate-in-menu="auto">
            <div>
              <DxButton icon="refresh" @click="onRefreshClick" />
            </div>
          </DxGridToolbarItem>
          <DxGridToolbarItem location="after" locate-in-menu="auto">
            <div>
              <div class="separator"></div>
            </div>
          </DxGridToolbarItem>
          <DxGridToolbarItem name="exportButton" />
          <DxGridToolbarItem location="after" locate-in-menu="auto">
            <div>
              <div class="separator"></div>
            </div>
          </DxGridToolbarItem>
          <DxGridToolbarItem name="columnChooserButton" locate-in-menu="auto" />
          <DxGridToolbarItem name="searchPanel" locate-in-menu="auto" />
        </DxGridToolbar>

        <DxTexts group-continued-message="Continuat de pe pagina anterioara"
          group-continues-message="Continuat pe pagina urmatoare" />
        <DxEditing :allowUpdating="true" :allowDeleting="true" mode="popup">
          <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" :width="800" :height="670">
            <DxToolbarItem :template="customTitleTemplate" />
            <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="successButtonOptions" />
            <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="dangerButtonOptions" />
          </DxPopup>
          <DxFormGrid :col-count="1">
            <DxFormItemGrid :col-count="3" item-type="group">

              <DxFormItemGrid data-field="AccountID" :col-span="3" :col-count="3" :label="{ text: 'Partener' }"
                editor-type="dxDropDownBox" :editor-options="{
                  dataSource: dsParteneri,
                  valueExpr: 'ID',
                  displayExpr: displayCompanie,
                  contentTemplate: 'content',
                  showClearButton: true
                }" />

              <DxFormItemGrid data-field="TipActivitateID" :col-span="3" :col-count="3"
                :label="{ text: 'Tip Activitate' }" editor-type="dxDropDownBox" :editor-options="{
                  dataSource: dsTipActivitati,
                  valueExpr: 'ID',
                  displayExpr: displayTipActivitate,
                  contentTemplate: 'content',
                  showClearButton: true
                }" />
              <DxFormItemGrid dataField="Cost" editorType="dxNumberBox" :editor-options="{
                format: '#0.00',
                showSpinButtons: true,
              }" />
              <DxFormItemGrid :label="{ text: 'Valută' }">
                <DxDropDownBox v-model:opened="isValuteGridBoxOpened" :data-source="valutaSelectat"
                  v-model:value="sValuta" display-expr="Simbol" value-expr="Id" :show-clear-button="true"
                  placeholder="RON">
                  <template #content="{ data }">
                    <DxDataGrid :data-source="dsValuta" v-model:value="sValuta" :columns="['Simbol']"
                      :hover-state-enabled="true" height="100%" @selection-changed="onValueSelectedValuta($event)">
                      <DxSelection mode="single" />
                      <DxPaging :enabled="true" :page-size="5" />
                      <DxFilterRow :visible="true" />
                      <DxSearchPanel :visible="true" placeholder="Cauta ..." />
                    </DxDataGrid>
                  </template>
                </DxDropDownBox>
              </DxFormItemGrid>

              <DxFormItemGrid dataField="Data" editorType="dxDateBox"
                :editor-options="{ displayFormat: 'dd/MM/yyyy', dateSerializationFormat: 'yyyy-MM-ddTHH:mm:ssZ' }" />
              <DxFormItemGrid dataField="Descriere" :col-count="3" :col-span="3" :editor-options="{ height: 100 }"
                editorType="dxTextArea" />

              <DxFormItemGrid item-type="simple" :col-span="3">
                <template #default>
                  <div class="edit-file-card">
                    <div class="edit-file-title">Documente / Fișiere</div>

                    <div v-if="isEditFilesLoading" class="edit-file-muted">Se încarcă...</div>

                    <div v-else-if="editActivityFiles.length === 0" class="edit-file-muted">
                      Nu există fișiere atașate.
                    </div>

                    <div v-else class="files-list">
                      <div class="file-row" v-for="f in editActivityFiles" :key="f.ID"
                        :class="{ active: selectedEditFile?.ID === f.ID }" @click="selectFileForReplace(f)">
                        <div class="file-name">{{ f.FileName }}</div>

                        <div class="file-actions">
                          <button type="button" class="dx-button dx-button-mode-text dx-button-normal dx-widget"
                            title="Descarcă" @click.stop="onDownloadFile(f)">
                            <span class="dx-button-content">
                              <i class="dx-icon dx-icon-download"></i>
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Replace -->
                    <div v-if="editActivityFiles.length > 0" class="replace-block">
                      <div class="replace-hint">
                        Se va înlocui: <b>{{ selectedEditFile?.FileName || '-' }}</b>
                      </div>

                      <input type="file" ref="editFileInput" style="display:none"
                        @change="onReplaceFileSelectedCustom" />

                      <div class="replace-row">
                        <span v-if="editReplaceFile" class="replace-new">
                          Nou: {{ editReplaceFile.name }}
                        </span>
                        <span v-else class="replace-none">
                          (Niciun fișier nou selectat)
                        </span>

                        <!-- Choose file -->
                        <button type="button" class="dx-button dx-button-mode-outlined dx-button-normal dx-widget"
                          :disabled="isLocked" @click="triggerFileSelect">
                          <span class="dx-button-content">
                            <i class="dx-icon dx-icon-upload"></i>
                            <span class="dx-button-text">Alege alt fișier</span>
                          </span>
                        </button>
                      </div>

                      <div class="replace-actions">
                        <!-- Replace -->
                        <button type="button" class="dx-button dx-button-mode-outlined dx-button-success dx-widget"
                          :disabled="!selectedEditFile?.ID || !editReplaceFile" @click="replaceCurrentFile">
                          <span class="dx-button-content">
                            <span class="dx-button-text">Înlocuiește</span>
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </template>
              </DxFormItemGrid>
            </DxFormItemGrid>
          </DxFormGrid>
        </DxEditing>
        <DxStateStoring :enabled="true" storage-key="CrmActivitati" :filter-value="dateFilterValue" />
        <DxColumn data-field="ID" :visible="false" :show-in-column-chooser="false" />
        <DxColumn data-field="Descriere" caption="Descriere" :cell-template="'descriereCellTemplate'" />

        <template #descriereCellTemplate="{ data }">
          <div class="descriere-cell">
            <i class="dx-icon-alignleft"></i>
            <span>{{ data.displayValue || '-' }}</span>
          </div>
        </template>

        <DxColumn data-field="Sale.Titlu" caption="Oportunitate" :cell-template="'saleCellTemplate'" />

        <template #saleCellTemplate="{ data }">
          <div class="sale-cell" @click.stop.prevent="openOportunitate(data.data.SaleID)">
            <i class="dx-icon-box"></i>
            <span>{{ data.displayValue || '-' }}</span>
          </div>
        </template>


        <DxColumn data-field="SaleID" :visible="false" :show-in-column-chooser="false"
          :edit-cell-template="'accountCellEditorSales'" />
        <template #accountCellEditorSales="{ data }">
          <DxDropDownBox :data-source="dsSales" value-expr="ID" :display-expr="displaySales" :value="data.value"
            v-model:opened="isSalesDdbOpen" :show-clear-button="true">
            <template #content>
              <DxDataGrid :data-source="dsSales" key-expr="ID" :columns="['Titlu']" height="100%" @selection-changed="e => {
                const id = e.selectedRowKeys?.[0] ?? null;
                data.setValue(id);
                isSalesDdbOpen = false;
              }">
                <DxSelection mode="single" />
              </DxDataGrid>
            </template>
          </DxDropDownBox>
        </template>
        <DxColumn data-field="Account.Nume" caption="Partener" :cell-template="'accountCellTemplate'" />

        <template #accountCellTemplate="{ data }">
          <div class="account-cell">
            <i class="dx-icon-home"></i>
            <span>{{ data.displayValue || '' }}</span>
          </div>
        </template>

        <DxColumn data-field="AccountID" :visible="false" :show-in-column-chooser="false"
          :edit-cell-template="'accountCellEditor'" />
        <template #accountCellEditor="{ data }">
          <DxDropDownBox :data-source="dsParteneri" value-expr="ID" :display-expr="displayCompanie" :value="data.value"
            v-model:opened="isAccountDdbOpen" :show-clear-button="true">
            <template #content>
              <DxDataGrid :data-source="dsParteneri" key-expr="ID" :columns="['Nume']" height="100%" @selection-changed="e => {
                const id = e.selectedRowKeys?.[0] ?? null;
                data.setValue(id);
                isAccountDdbOpen = false;
              }">
                <DxSelection mode="single" />
              </DxDataGrid>
            </template>
          </DxDropDownBox>
        </template>
        <DxColumn data-field="TipActivitate.Nume" caption="Tip Activitate"
          :cell-template="'tipActivitateCellTemplate'" />

        <template #tipActivitateCellTemplate="{ data }">
          <div class="tip-activitate-cell">
            <i class="dx-icon-todo"></i>
            <span>{{ data.displayValue || '-' }}</span>
          </div>
        </template>

        <DxColumn data-field="TipActivitateID" :visible="false" :show-in-column-chooser="false"
          :edit-cell-template="'accountCellEditorTipActivitate'" />
        <template #accountCellEditorTipActivitate="{ data }">
          <DxDropDownBox :data-source="dsTipActivitati" value-expr="ID" :display-expr="displayTipActivitate"
            :value="data.value" v-model:opened="isActivityDdbOpen" :show-clear-button="true">
            <template #content>
              <DxDataGrid :data-source="dsTipActivitati" key-expr="ID" :columns="['Nume']" height="100%"
                @selection-changed="e => {
                  const id = e.selectedRowKeys?.[0] ?? null;
                  data.setValue(id);
                  isActivityDdbOpen = false;
                }">
                <DxSelection mode="single" />
              </DxDataGrid>
            </template>
          </DxDropDownBox>
        </template>
        <DxColumn data-field="NumeFisier" :visible="false" />
        <DxColumn data-field="Path" :visible="false" />
        <DxColumn data-field="Globala" :visible="false" />
        <DxColumn data-field="Cost" :visible="false" />
        <DxColumn data-field="Durata" :visible="false" />
        <DxColumn data-field="Valuta.Simbol" :visible="false" caption="Valuta" />
        <DxColumn data-field="Curs" :visible="false" />
        <DxColumn data-field="Data" caption="Data" data-type="date" :cell-template="'dateCellTemplate'" />

        <template #dateCellTemplate="{ data }">
          <div class="date-cell">
            <i class="dx-icon-event"></i>
            <span>{{ formatDate(data.value) }}</span>
          </div>
        </template>

        <DxColumn data-field="Owner" caption="Responsabil" :allow-editing="false" />

        <DxColumn type="buttons" :buttons="[
          {
            hint: 'Vezi detalii',
            icon: 'info',
            onClick: onViewDetails
          },
          {
            name: 'edit',
            visible: isEditVisible
          },
          {
            name: 'delete',
            visible: isDeleteVisible
          }
        ]" />
      </DxDataGrid>
    </div>

    <DxPopupAdd v-model:visible="isActivityDetailsVisible" :drag-enabled="false" :hide-on-outside-click="true"
      :show-close-button="true" :width="750" :height="700">
      <template #title>
        <div class="popup-header popup-header--activity">
          <div class="popup-header-main">
            <span class="popup-header-icon dx-icon-task"></span>
            <div class="popup-header-texts">
              <div class="popup-header-title">{{ selectedActivity.TipActivitate || 'Activitate CRM' }}</div>
            </div>
          </div>

        </div>
      </template>

      <DxScrollView width="100%" height="100%" class="details-scroll-view">
        <div class="details-container">
          <!-- Quick Stats Row -->
          <div class="stats-grid">
            <div class="stat-card stat-card--cost">
              <div class="stat-icon dx-icon-money"></div>
              <div class="stat-content">
                <div class="stat-label">Cost Estimativ</div>
                <div class="stat-value">{{ formatCurrency(selectedActivity.Cost, selectedActivity.Valuta) }}</div>
              </div>
            </div>
            <div class="stat-card stat-card--date">
              <div class="stat-icon dx-icon-event"></div>
              <div class="stat-content">
                <div class="stat-label">Data Planificată</div>
                <div class="stat-value">{{ formatDate(selectedActivity.Data) }}</div>
              </div>
            </div>
          </div>

          <!-- Main Info Grid -->
          <div class="info-sections-grid">
            <!-- Left Column: Context -->
            <div class="info-column">
              <div class="info-section-card">
                <div class="section-header">
                  <span class="dx-icon-link section-icon"></span>
                  <span>Context Activitate</span>
                </div>
                <div class="info-list">
                  <div class="info-item">
                    <label>Partener</label>
                    <div class="value">{{ selectedActivity.Account || '-' }}</div>
                  </div>
                  <div class="info-item">
                    <label>Oportunitate Asociată</label>
                    <div class="value highlight">
                      <a href="#" @click.prevent="openOportunitate(selectedActivity.SaleID)"
                        v-if="selectedActivity.SaleID" class="link-oportunitate">{{ selectedActivity.Sale || '-' }}</a>
                      <span v-else>{{ selectedActivity.Sale || '-' }}</span>
                    </div>
                  </div>
                  <div class="info-item">
                    <label>Tip Activitate</label>
                    <div class="value">{{ selectedActivity.TipActivitate || '-' }}</div>
                  </div>
                </div>
              </div>

              <div class="info-section-card">
                <div class="section-header">
                  <span class="dx-icon-floppy section-icon"></span>
                  <span>Documente / Fișiere</span>
                </div>

                <div class="info-list">
                  <div v-if="isFilesLoading" class="info-item">
                    <div class="value">Se încarcă fișierele...</div>
                  </div>

                  <div v-else-if="activityFiles.length === 0" class="info-item">
                    <div class="value">Nu există fișiere atașate.</div>
                  </div>

                  <div v-else class="info-item">
                    <label>Fișiere</label>

                    <div class="files-list">
                      <div class="file-row" v-for="f in activityFiles" :key="f.ID">
                        <div class="file-name">{{ f.FileName }}</div>

                        <div class="file-actions">
                          <DxButton icon="download" styling-mode="text" hint="Descarcă"
                            @click="() => onDownloadFile(f)" />
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <!-- Right Column: Details -->
            <div class="info-column">
              <div class="info-section-card">
                <div class="section-header">
                  <span class="dx-icon-doc section-icon"></span>
                  <span>Descriere & Note</span>
                </div>
                <div class="info-list">
                  <div class="info-item">
                    <label>Descriere Detaliată</label>
                    <div class="value multiline">{{ selectedActivity.Descriere || '-' }}</div>
                  </div>
                </div>
              </div>

              <div class="info-section-card">
                <div class="section-header">
                  <span class="dx-icon-info section-icon"></span>
                  <span>Informații Financiare</span>
                </div>
                <div class="info-list">
                  <div class="info-item">
                    <label>Valoare (Cost)</label>
                    <div class="value success">{{ formatCurrency(selectedActivity.Cost, selectedActivity.Valuta) }}
                    </div>
                  </div>
                  <div class="info-item">
                    <label>Curs Valutar</label>
                    <div class="value">{{ selectedActivity.Curs || '1.0000' }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Bottom Meta Section -->
          <div class="system-meta-card">
            <div class="meta-row">
              <div class="meta-item">
                <span class="dx-icon-user meta-icon"></span>
                <span>Creat de <strong>{{ selectedActivity.UserCreat || 'Sistem' }}</strong> la {{
                  formatDate(selectedActivity.DataCreat, true) }}</span>
              </div>
            </div>
          </div>
        </div>
      </DxScrollView>
    </DxPopupAdd>
    <DxPopupAdd :visible.sync="isModalVisible" :closeOnOutsideClick="false" :showCloseButton="false" :showTitle="true"
      :width="700" :height="680">
      <template #title>
        <div class="popup-header">
          <div class="popup-header-main">
            <span class="popup-header-icon dx-icon-add"></span>
            <div class="popup-header-texts">
              <div class="popup-header-title">Adăugare activitate</div>
              <div class="popup-header-subtitle">
                Completează informațiile în pașii de mai jos
              </div>
            </div>
          </div>
          <div class="popup-header-meta">
            <span class="status-chip status-chip--draft">
              Nouă
            </span>
          </div>
        </div>
      </template>
      <div ref="popupBody" class="popup-body-simple popup-body-modern">
        <div class="form-content form-content-modern">
          <DxForm :formData="formData">
            <DxFormItem :col-span="3" :col-count="3" item-type="group">

              <DxFormItem :label="{ text: 'Partener' }" :col-count="3" :col-span="3">
                <DxRequiredRule message="Câmpul 'Partener' este obligatoriu" />
                <DxDropDownBox v-model:opened="isParteneriGridBoxOpened" :data-source="partenerSelectat"
                  v-model:value="formData.AccountID" :show-clear-button="true" display-expr="Nume" value-expr="ID">
                  <template #content>
                    <DxDataGrid :data-source="dsParteneri" :columns="['Nume']" :hover-state-enabled="true" height="100%"
                      @selection-changed="onValueSelectedPartener">
                      <DxSelection mode="single" />
                      <DxPaging :enabled="true" :page-size="10" />
                      <DxFilterRow :visible="true" />
                      <DxSearchPanel :visible="true" placeholder="Caută ..." />
                    </DxDataGrid>
                  </template>
                </DxDropDownBox>
              </DxFormItem>

              <DxFormItem :label="{ text: 'Tip Activitate' }" :col-count="3" :col-span="3">
                <DxRequiredRule message="Câmpul 'Tip Activitate' este obligatoriu" />
                <DxDropDownBox v-model:opened="isTipActivitateGridBoxOpened" :data-source="tipActivitateSelectat"
                  v-model:value="sTipActivitate" :show-clear-button="true" display-expr="Nume" value-expr="ID">
                  <template #content="{ data }">
                    <DxDataGrid :data-source="dsTipActivitati" :columns="['Nume']" :hover-state-enabled="true"
                      height="100%" @selection-changed="onValueSelectedTipActivitate">
                      <DxSelection mode="single" />
                      <DxFilterRow :visible="true" />
                      <DxSearchPanel :visible="true" placeholder="Caută ..." />
                    </DxDataGrid>
                  </template>
                </DxDropDownBox>
              </DxFormItem>

              <DxFormItem dataField="Cost" editorType="dxNumberBox" :editor-options="{
                format: '#0.00',
                showSpinButtons: true,
              }" />

              <DxFormItem :label="{ text: 'Valuta' }">
                <DxDropDownBox v-model:opened="isValuteGridBoxOpened" :data-source="valutaSelectat"
                  v-model:value="sValuta" :show-clear-button="true" display-expr="Simbol" value-expr="Id"
                  placeholder="RON">
                  <template #content="{ data }">
                    <DxDataGrid :data-source="dsValuta" v-model:value="sValuta" :columns="['Simbol']"
                      :hover-state-enabled="true" height="100%" @selection-changed="onValueSelectedValuta">
                      <DxSelection mode="single" />
                      <DxPaging :enabled="true" :page-size="5" />
                      <DxFilterRow :visible="true" />
                      <DxSearchPanel :visible="true" placeholder="Cauta ..." />
                    </DxDataGrid>
                  </template>
                </DxDropDownBox>
              </DxFormItem>

              <DxFormItem dataField="Data" editorType="dxDateBox"
                :editor-options="{ displayFormat: 'dd/MM/yyyy', dateSerializationFormat: 'yyyy-MM-ddTHH:mm:ssZ' }" />

              <DxFormItem dataField="Descriere" :col-count="3" :col-span="3" :editor-options="{ height: 100 }"
                editorType="dxTextArea">
                <DxRequiredRule message="Câmpul 'Descriere' este obligatoriu" />
              </DxFormItem>

              <DxFormItem :col-span="3">
                <template #default>
                  <div style="display:flex; flex-direction:column; gap:8px;">
                    <!-- Custom File Input for ADD -->
                    <!-- Added 'multiple' attribute -->
                    <input type="file" multiple ref="addFileInput" id="addActivityInputHidden" style="display: none"
                      @change="onAddFileSelectedCustom" />

                    <div style="display:flex; justify-content:space-between; align-items:center;">
                      <div class="selected-files-list" style="flex:1;">
                        <div v-if="selectedFiles && selectedFiles.length > 0">
                          <div v-for="(file, index) in selectedFiles" :key="index"
                            style="display:flex; align-items:center; gap:6px; font-size:13px; font-weight:600; color:#059669; margin-bottom:4px;">
                            <span>{{ file.name }}</span>
                            <span class="dx-icon-remove" style="cursor:pointer; color:#ef4444;"
                              @click="removeFile(index)" title="Șterge fișier"></span>
                          </div>
                        </div>
                        <span v-else style="font-size:12px; color:#94a3b8;">
                          (Niciun fișier selectat)
                        </span>
                      </div>

                      <DxButton text="Alege fișiere" icon="upload" styling-mode="outlined" type="default"
                        @click="triggerAddFileSelect" />
                    </div>
                  </div>
                </template>
              </DxFormItem>
            </DxFormItem>
          </DxForm>
        </div>
        <div class="form-footer footer-fixed footer-modern">
          <div class="footer-left">
            <DxButton text="Programează activitate următoare" type="success" width="auto" height="32"
              styling-mode="outlined" :use-submit-behavior="false" @click="() => onSaveAdd(true)" />
          </div>
          <div class="footer-right">
            <DxButton text="Salvează" type="success" width="100" height="32" styling-mode="outlined"
              @click="() => onSaveAdd(false)" />
            <DxButton text="Închide" type="danger" width="100" height="32" styling-mode="outlined" @click="onCancel" />
          </div>
        </div>
      </div>
    </DxPopupAdd>

  </div>
</template>
<script lang="ts">
import { DxRequiredRule } from 'devextreme-vue/validator';
import DxDateBox from 'devextreme-vue/date-box';
import DxDropDownButton, { DxDropDownButtonTypes } from 'devextreme-vue/drop-down-button';
import { defineComponent, ref } from 'vue';
import { DxButton } from 'devextreme-vue/button';
import DxPopupAdd from 'devextreme-vue/popup';
import { DxSimpleItem, DxLabel } from 'devextreme-vue/form';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import { DxForm, DxItem as DxFormItem } from 'devextreme-vue/form';
import DataSource from "devextreme/data/data_source";
import DxDropDownBox from "devextreme-vue/drop-down-box";
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
import notify from 'devextreme/ui/notify';
import { jsPDF } from 'jspdf';
import { exportDataGrid as exportDataGridPdf } from 'devextreme/pdf_exporter';
import { exportDataGrid as exportDataGridExcel } from 'devextreme/excel_exporter';
import JwtServices from '@/services/JwtServices';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import CrmActivitati from '@/services/Comercial/CrmActivitati';
import { locale, loadMessages } from 'devextreme/localization';
import {
  DxItem as DxGridToolbarItem,
  DxLookup,
  DxColumn,
  DxDataGrid,
  DxFilterRow,
  DxLoadPanel,
  DxPaging,
  DxSelection,
  DxSorting,
  DxStateStoring,
  DxToolbar as DxGridToolbar,
  DxEditing,
  DxColumnChooser,
  DxGrouping,
  DxGroupPanel,
  DxTexts,
  DxExport,
  DxSearchPanel,
  DxMasterDetail,
  DxPopup,
  DxToolbarItem,
  DxForm as DxFormGrid,
  DxItem as DxFormItemGrid,
  DxScrolling,
  DxHeaderFilter,

} from 'devextreme-vue/data-grid';

export default defineComponent({
  components: {
    DxGridToolbar,
    DxDataGrid,
    DxColumn,
    DxSorting,
    DxSelection,
    DxFilterRow,
    DxStateStoring,
    DxLoadPanel,
    DxPaging,
    DxButton,
    DxEditing,
    DxPopupAdd,
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxLabel,
    DxScrollView,
    DxLookup,
    DxColumnChooser,
    DxGrouping,
    DxGroupPanel,
    DxTexts,
    DxExport,
    DxSearchPanel,
    DxMasterDetail,
    DxPopup,
    DxToolbarItem,
    DxFormGrid,
    DxGridToolbarItem,
    DxScrolling,
    DxHeaderFilter,
    DxDropDownButton,
    DxFormItem,
    DxDropDownBox,
    DxFormItemGrid,
    DxDateBox
  },

  props: {
    isLocked: {
      type: Boolean,
      default: false
    }
  },
  data() {

    return {
      _searchClearedOnce: false,
      partenerSelectat: [],
      isParteneriGridBoxOpened: false,
      sPartener: null,

      isOportunitateGridBoxOpened: false,
      sOportunitate: null,
      oportunitateSelectat: [],

      tipActivitateSelectat: [],
      isTipActivitateGridBoxOpened: false,
      sTipActivitate: null,

      selectedFiles: [] as File[],

      isFilesLoading: false,
      activityFiles: [] as any[],

      isEditFilesLoading: false,
      editActivityFiles: [] as any[],
      selectedEditFile: null as any,
      editReplaceFile: null as File | null,
      currentEditingActivityId: null as string | null,

      valutaSelectat: [],
      isValuteGridBoxOpened: false,
      sValuta: null,

      dsActivitati: {} as ODataStore,
      dsSales: {} as ODataStore,
      dsParteneri: {} as ODataStore,
      dsValuta: {} as ODataStore,
      dsTipActivitati: {} as ODataStore,
      isModalVisible: false,
      isActivityDetailsVisible: false,
      dataGrid: ref<DxDataGrid | null>(null),
      deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",
      isAccountDdbOpen: false as boolean,
      isActivityDdbOpen: false as boolean,
      isSalesDdbOpen: false as boolean,
      dateFrom: null as Date | null,
      dateTo: null as Date | null,
      dateFilterValue: null as any,
      selectedActivity: {
        Descriere: '',
        SaleID: null,
        AccountID: null,
        TipActivitateID: null,
        NumeFisier: '',
        Path: '',
        UserCreat: '',
        DataCreat: null,
        Globala: false,
        Cost: null,
        Durata: null,
        ValutaID: null,
        Curs: null,
        Data: null,
        Sale: '',
        Account: '',
        Valuta: '',
        TipActivitate: '',

      },
      formData: {
        Descriere: '',
        SaleID: null,
        AccountID: null,
        TipActivitateID: null,
        NumeFisier: '',
        Path: '',
        UserCreat: '',
        DataCreat: null,
        Globala: true,
        Cost: null,
        Durata: null,
        ValutaID: null,
        Curs: null,
        Data: null,
        Sale: '',
        Account: '',
        Valuta: '',
        TipActivitate: ''
      },
      Username: "",
      dashboardStats: {
        total: 0,
        today: 0,
        upcoming: 0,
        overdue: 0
      },
      activeDashboardFilter: null as string | null,
      successButtonOptions: {
        type: 'success',
        stylingMode: 'contained',
        text: 'Salvează',
        onClick: () => {
          this.SaveEdit();
        },
      },
      dangerButtonOptions: {
        type: 'danger',
        stylingMode: 'contained',
        text: 'Închide',
        onClick: () => {
          this.onCancel();
        },
      },
      customTitleTemplate() {
        return `
           <div class="popup-header" style="width: 800px; margin: -5px -20px 0 -20px; padding: 16px 24px; background: linear-gradient(90deg, #ff2c21, #ff6a4a); display: flex; align-items: center; gap: 16px;">
             <span class="dx-icon-edit" style="font-size: 24px; width: 30px; height: 40px; display: flex; align-items: center; justify-content: center; border-radius: 8px; color: white;"></span>
             <div style="display: flex; flex-direction: column; color: white;">
                <span style="font-size: 16px; font-weight: 700;">Editare Activitate existentă</span>
                <span style="font-size: 12px; opacity: 0.9;">Modifică detaliile activității selectate</span>
             </div>
          </div>
          `;
      },
    };
  },
  watch: {
    sOportunitate(newId) {
      if (newId) {
        this.dsSales.store().byKey(newId).then(x => {
          if (!x) return;
          x.Titlu = (x.Titlu ?? '(fara nume)');
          this.oportunitateSelectat = [x];
        });

      } else {
        this.oportunitateSelectat = [];
      }
    },
    sPartener(newId) {
      if (newId) {
        this.dsParteneri.store().byKey(newId).then(x => {
          if (!x) return;
          x.Nume = (x.Nume ?? '(fara nume)');
          this.partenerSelectat = [x];
        });
      } else {
        this.partenerSelectat = [];
      }
    },
    sTipActivitate(newId) {
      if (newId) {
        this.dsTipActivitati.store().byKey(newId).then(x => {
          if (!x) return;
          x.Nume = (x.Nume ?? '(fara nume)');
          this.tipActivitateSelectat = [x];
        });

      } else {
        this.tipActivitateSelectat = [];
      }
    },
    sValuta(newId) {
      if (newId) {
        this.dsValuta.store().byKey(newId).then(x => {
          if (!x) return;
          x.Simbol = (x.Simbol ?? '(fara nume)');
          this.valutaSelectat = [x];
        });

      } else {
        this.valutaSelectat = [];
      }
    },
  },
  methods: {
    removeSearchTextFromStoredState(storageKey: string) {
      // DevExtreme folosește diferite prefixuri în funcție de versiune/config.
      const candidates = [
        storageKey,
        `dx-data-grid-state-${storageKey}`,
        `dx-data-grid-${storageKey}`,
      ];

      for (const k of candidates) {
        const raw = localStorage.getItem(k);
        if (!raw) continue;

        try {
          const state = JSON.parse(raw);
          if ("searchText" in state) {
            delete state.searchText;
            localStorage.setItem(k, JSON.stringify(state));
          }
        } catch { /* ignore */ }
      }
    },
    onGridContentReady(e: any) {
      if (this._searchClearedOnce) return;

      // aici starea e deja aplicată (inclusiv searchText), deci îl poți șterge sigur
      e.component.option("searchPanel.text", "");
      this._searchClearedOnce = true;
    },
    formatDate(value: string | Date | null, includeTime = false) {
      if (!value) return '';

      const d = new Date(value);
      const options: Intl.DateTimeFormatOptions = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      };

      if (includeTime) {
        options.hour = '2-digit';
        options.minute = '2-digit';
      }

      return d.toLocaleDateString('ro-RO', options);
    },
    formatCurrency(value: number, currency: string) {
      if (value === null || value === undefined) return '-';
      return new Intl.NumberFormat('ro-RO', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value) + ' ' + (currency || 'RON');
    },
    setDefaultDateRange() {
      const today = new Date();
      const from = new Date();
      from.setDate(today.getDate() - 30);

      from.setHours(0, 0, 0, 0);
      today.setHours(23, 59, 59, 999);

      this.dateFrom = from;
      this.dateTo = today;
      this.applyDateFilter();
    },
    openOportunitate(saleId: string | null) {
      if (!saleId) {
        return;
      }
      this.$router.push({ name: 'GridOportunitati', query: { opportunityId: saleId } });
    },

    applyDateFilter() {
      let filter = [];
      if (this.dateFrom) {
        filter.push(["Data", ">=", this.dateFrom]);
      }
      if (this.dateTo) {
        if (filter.length > 0) filter.push("and");
        filter.push(["Data", "<=", this.dateTo]);
      }

      this.dateFilterValue = filter.length > 0 ? filter : null;
    },

    onDateChanged() {
      this.activeDashboardFilter = null;
      this.applyDateFilter();
    },
    async loadDashboardMetrics() {
      try {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);

        const token = localStorage.getItem("ERA_Jwt");
        const headers = {
          "Authorization": "Bearer " + token
        };
        const baseUrl = AppSetting.API_Url_ComercialOdata + 'CRM_Activitati/$count';

        const todayStr = today.toISOString();
        const tomorrowStr = tomorrow.toISOString();

        const queryToday = `${baseUrl}?$filter=Data ge ${todayStr} and Data lt ${tomorrowStr}`;
        const queryFuture = `${baseUrl}?$filter=Data ge ${tomorrowStr}`;
        const queryPast = `${baseUrl}?$filter=Data lt ${todayStr}`;

        const [reqToday, reqFuture, reqPast, reqTotal] = await Promise.all([
          fetch(queryToday, { headers }),
          fetch(queryFuture, { headers }),
          fetch(queryPast, { headers }),
          fetch(baseUrl, { headers })
        ]);

        this.dashboardStats.today = await reqToday.text();
        this.dashboardStats.upcoming = await reqFuture.text();
        this.dashboardStats.overdue = await reqPast.text();
        this.dashboardStats.total = await reqTotal.text();

      } catch (e) {
        console.error("Failed to load metrics", e);
      }
    },
    filterDashboard(type: string) {
      this.activeDashboardFilter = type;
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);

      if (type === 'total') {
        this.dateFrom = null;
        this.dateTo = null;
      } else if (type === 'today') {
        this.dateFrom = today;

        const endOfToday = new Date(today);
        endOfToday.setHours(23, 59, 59, 999);
        this.dateTo = endOfToday;
      } else if (type === 'upcoming') {
        this.dateFrom = tomorrow;
        this.dateTo = null;
      } else if (type === 'overdue') {
        this.dateFrom = null;

        const endOfYesterday = new Date(today);
        endOfYesterday.setMilliseconds(-1);
        this.dateTo = endOfYesterday;
      }
      this.applyDateFilter();
    },
    createODataContext() {
      this.dsActivitati = new ODataStore({
        url: AppSetting.API_Url_ComercialOdata + 'CRM_Activitati',
        key: 'ID',
        keyType: "Guid",
        version: 4,
        beforeSend: (e) => {
          e.headers = {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt"),
          };

          e.params.$expand = "Sale($select=Titlu),Account($select=Nume),TipActivitate($select=Nume),Valuta($select=Simbol)";

        }
      });
      this.dsSales = new DataSource({
        store: {
          type: 'odata',
          url: AppSetting.API_Url_ComercialOdata + 'CRM_Sales',
          key: 'ID',
          keyType: "Guid",
          version: 4,

          beforeSend: (e: any) => {

            e.headers = {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

            };
          }
        },
        select: [
          'ID',
          'Titlu',
        ],

      });
      this.dsParteneri = new DataSource({
        store: {
          type: 'odata',
          url: AppSetting.API_Url_ComercialOdata + 'PAR_Parteneri',
          key: 'ID',
          keyType: "Guid",
          version: 4,

          beforeSend: (e: any) => {

            e.headers = {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

            };
          }
        },
        select: [
          'ID',
          'Nume',
        ],

      });
      this.dsTipActivitati = new DataSource({
        store: {
          type: 'odata',
          url: AppSetting.API_Url_ComercialOdata + 'CRM_CautareTipuriActivitati',
          key: 'ID',
          keyType: "Guid",
          version: 4,

          beforeSend: (e: any) => {

            e.headers = {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

            };
          }
        },
        select: [
          'ID',
          'Nume',
        ],

      });

      this.dsValuta = new DataSource({
        store: {
          type: 'odata',
          url: AppSetting.API_Url_ComercialOdata + 'ERP_Valute',
          key: 'Id',
          keyType: "Guid",
          version: 4,

          beforeSend: (e: any) => {

            e.headers = {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

            };
          }
        },
        select: [
          'Id',
          'Simbol',
        ],

      });
    },
    displayCompanie(item) {
      return item ? (item.Nume || '(fără nume)') : '';
    },

    displayTipActivitate(item) {
      return item ? (item.Nume || '(fara nume)') : '';
    },
    displaySales(item) {
      return item ? (item.Titlu || '(fara nume)') : '';
    },
    onValueSelectedPartener(e) {

      this.isParteneriGridBoxOpened = false;

      if (e.selectedRowKeys.length > 0) {
        this.sPartener = e.selectedRowKeys[0];

      } else {
        this.sPartener = null;
      }
      this.formData.AccountID = this.sPartener;

    },
    onValueSelectedOportunitate(e) {
      this.isOportunitateGridBoxOpened = false;

      if (e.selectedRowKeys.length > 0) {
        this.sOportunitate = e.selectedRowKeys[0];

      } else {
        this.sOportunitate = null;
      }
      this.formData.SaleID = this.sOportunitate;

    },
    onValueSelectedTipActivitate(e) {
      this.isTipActivitateGridBoxOpened = false;

      if (e.selectedRowKeys.length > 0) {
        this.sTipActivitate = e.selectedRowKeys[0];

      } else {
        this.sTipActivitate = null;
      }
      this.formData.TipActivitateID = this.sTipActivitate;

    },
    onValueSelectedValuta(e) {
      this.isValuteGridBoxOpened = false;

      if (e.selectedRowKeys.length > 0) {
        this.sValuta = e.selectedRowKeys[0];

      } else {
        this.sValuta = null;
      }
      this.formData.ValutaID = this.sValuta;
    },
    onEditingStart(e: any) {
      if (e.data.Owner !== this.Username) {
        e.cancel = true;
        notify('Puteți edita doar activitățile unde sunteți responsabil!', 'error', 2000);
        return;
      }
      const id = e?.data?.ID;
      this.currentEditingActivityId = id || null;
      this.editReplaceFile = null;
      this.selectedEditFile = null;
      this.editActivityFiles = [];
      if (id) this.loadEditFiles(id);
    },
    async loadEditFiles(activityId: string) {
      try {
        this.isEditFilesLoading = true;
        const res = await CrmActivitati.list(activityId);
        this.editActivityFiles = Array.isArray(res.data) ? res.data : [];
        this.selectedEditFile = this.editActivityFiles.length ? this.editActivityFiles[0] : null;
      } catch (err) {
        console.error(err);
        this.editActivityFiles = [];
        this.selectedEditFile = null;
        notify("Nu am putut încărca fișierele pentru editare.", "error", 1500);
      } finally {
        this.isEditFilesLoading = false;
      }
    },
    selectFileForReplace(f: any) {
      this.selectedEditFile = f;
      this.editReplaceFile = null;
      if (this.$refs.editFileInput) (this.$refs.editFileInput as HTMLInputElement).value = '';
    },
    triggerFileSelect() {
      if (this.$refs.editFileInput) {
        (this.$refs.editFileInput as HTMLInputElement).click();
      }
    },
    onReplaceFileSelectedCustom(e: any) {
      const target = e.target;
      const files = target.files;
      if (files && files.length > 0) {
        this.editReplaceFile = files[0];
      } else {
        this.editReplaceFile = null;
      }
    },
    async replaceCurrentFile() {
      if (!this.editReplaceFile || !this.selectedEditFile?.ID) return;
      try {
        await CrmActivitati.replace(this.selectedEditFile.ID, this.editReplaceFile);
        notify("Fișier înlocuit cu succes!", "success", 2000);
        this.editReplaceFile = null;
        if (this.$refs.editFileInput) (this.$refs.editFileInput as HTMLInputElement).value = '';
        if (this.currentEditingActivityId) {
          await this.loadEditFiles(this.currentEditingActivityId);
        }
      } catch (err) {
        console.error(err);
        notify("Eroare la înlocuire fișier", "error", 2000);
      }
    },
    async loadActivityFiles(activityId: string) {
      try {
        this.isFilesLoading = true;
        const res = await CrmActivitati.list(activityId);
        const data = res?.data;
        this.activityFiles = Array.isArray(data) ? data : [];
      } catch (err) {
        console.error("Load files error:", err);
        this.activityFiles = [];
      } finally {
        this.isFilesLoading = false;
      }
    },
    async onDownloadFile(file: any) {
      try {
        const res = await CrmActivitati.download(file.ID);
        const fileName = file.FileName || "fisier";
        const blob = new Blob([res.data], { type: file.ContentType || "application/octet-stream" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
      } catch (err) {
        console.error("Download error:", err);
        notify("Eroare la descărcare fișier.", "error", 1500);
      }
    },
    onViewDetails(e: any) {
      const rowData = e?.row?.data;
      if (rowData) {
        this.showActivityDetails(rowData);
      }
    },
    async showActivityDetails(activity: any) {
      this.selectedActivity = {
        ...activity,
        Sale: activity.Sale?.Titlu || '-',
        Account: activity.Account?.Nume || '-',
        TipActivitate: activity.TipActivitate?.Nume || '-',
        Valuta: activity.Valuta?.Simbol || '-'
      };
      this.isActivityDetailsVisible = true;
      await this.$nextTick();
      await this.loadActivityFiles(this.selectedActivity.ID);
    },
    onAddClick() {
      this.formData = {
        Descriere: '',
        SaleID: null,
        AccountID: null,
        TipActivitateID: null,
        NumeFisier: '',
        Path: '',
        UserCreat: '',
        DataCreat: null,
        Globala: false,
        Cost: null,
        Durata: null,
        ValutaID: null,
        Curs: null,
        Data: new Date(),
      };
      this.sOportunitate = null;
      this.sPartener = null;
      this.sTipActivitate = null;
      this.sValuta = null;
      this.selectedFiles = []; // Reset file list
      this.isModalVisible = true;
    },
    triggerAddFileSelect() {
      const input = document.getElementById('addActivityInputHidden') as HTMLInputElement;
      if (input) input.click();
    },
    onAddFileSelectedCustom(e: Event) {
      const target = e.target as HTMLInputElement;
      const files = target.files;
      if (files && files.length > 0) {
        const newFiles = Array.from(files);
        this.selectedFiles = [...this.selectedFiles, ...newFiles];
        target.value = '';
      }
    },
    removeFile(index: number) {
      this.selectedFiles.splice(index, 1);
    },
    async onSaveAdd(keepOpen = false) {
      if (!this.formData.TipActivitateID) {
        notify('Completați câmpul obligatoriu "Tip Activitate"!', 'error', 1000);
        return;
      }

      if (!this.formData.Descriere || this.formData.Descriere.trim() === '') {
        notify('Completați câmpul obligatoriu "Descriere"!', 'error', 1000);
        return;
      }

      const cleanedFormData = { ...this.formData };
      const toNullIfEmpty = (val) => {
        return val === '' || val === undefined ? null : val;
      };
      if (cleanedFormData.Data) {
        cleanedFormData.Data = new Date(cleanedFormData.Data);
      }
      cleanedFormData.Globala = cleanedFormData.Globala ? true : null;

      const fieldsToNull = [
        'Data', 'Globala', 'Curs',
        'SaleID', 'AccountID', 'TipActivitateID', 'Cost',
        'Durata', 'ValutaID'
      ];
      fieldsToNull.forEach((field) => {
        cleanedFormData[field] = toNullIfEmpty(cleanedFormData[field]);
      });

      cleanedFormData.Owner = this.Username;

      try {
        const res = await CrmActivitati.save(cleanedFormData);
        const activityId = res?.data?.ID || res?.data?.value?.ID;

        // upload files
        if (activityId && this.selectedFiles && this.selectedFiles.length > 0) {
          for (const file of this.selectedFiles) {
            try {
              await CrmActivitati.uploadActivityFile(activityId, file);
            } catch (err) {
              console.error(`Error uploading file ${file.name}:`, err);
              notify(`Eroare la încărcarea fișierului ${file.name}`, 'error', 2000);
            }
          }
        }

        if (keepOpen !== true) {
          this.isModalVisible = false;
          notify('Activitate salvată cu succes!', 'success', 2000);
        } else {
          notify('Activitate salvată. Puteți programa acum următoarea acțiune.', 'info', 3000);
        }

        if (keepOpen === true) {
          // Partial reset
          this.formData.Descriere = '';
          const nextDate = new Date();
          nextDate.setDate(nextDate.getDate() + 1);
          this.formData.Data = nextDate; // next day
          this.formData.Cost = null;
          this.formData.Durata = null;
          this.formData.NumeFisier = '';
          this.formData.Path = '';
          this.selectedFiles = [];
        } else {
          // Full reset
          this.formData = {
            Descriere: '',
            SaleID: null,
            AccountID: null,
            TipActivitateID: null,
            NumeFisier: '',
            Path: '',
            UserCreat: '',
            DataCreat: null,
            Globala: false,
            Cost: null,
            Durata: null,
            ValutaID: null,
            Curs: null,
            Data: null,
          };
          this.sOportunitate = null;
          this.sPartener = null;
          this.sTipActivitate = null;
          this.sValuta = null;
          this.selectedFiles = [];
        }
        this.createODataContext();
      } catch (error) {
        console.error(error);
        notify('Eroare la salvare!', 'error', 1500);
      }
    },
    onRefreshClick() {
      this.createODataContext();
      notify('Datele au fost actualizate cu succes!', 'success', 1000);
    },
    async SaveEdit() {
      try {
        await this.$refs.dataGrid?.instance?.saveEditData();
        notify('Activitate salvată cu succes!', 'success', 1500);

        if (this.editReplaceFile && this.currentEditingActivityId) {
          if (this.selectedEditFile?.ID) {
            await CrmActivitati.replace(this.selectedEditFile.ID, this.editReplaceFile);
          } else {
            await CrmActivitati.upload(this.currentEditingActivityId, this.editReplaceFile);
          }
          await this.loadEditFiles(this.currentEditingActivityId);
          this.editReplaceFile = null;
        }
      } catch (error) {
        notify('Eroare la salvarea datelor!', 'error', 1000);
      }
    },
    onCancel() {
      this.isModalVisible = false;
      this.$refs.dataGrid?.instance?.cancelEditData();
    },
    onRowRemoving(e: any) {
      if (e.data.Owner !== this.Username) {
        e.cancel = true;
        notify('Puteți șterge doar activitățile unde sunteți responsabil!', 'error', 2000);
      }
    },
    onRowRemoved() {
      notify('Datele au fost șterse cu succes!', 'success', 1000);
    },
    isDeleteVisible(e: any) {
      return e.row.data.Owner === this.Username;
    },
    isEditVisible(e: any) {
      return e.row.data.Owner === this.Username;
    },
    onExporting(e: any) {
      if (e.format === 'pdf') {
        const doc = new jsPDF();
        exportDataGridPdf({
          jsPDFDocument: doc,
          component: e.component,
          indent: 5,
        }).then(() => {
          doc.save('CrmContacts.pdf');
        });
      } else if (e.format === 'xlsx') {

        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('preturi');

        exportDataGridExcel({
          component: e.component,
          worksheet,
          autoFilterEnabled: true,
        }).then(() => {
          workbook.xlsx.writeBuffer().then((buffer: any) => {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'CrmContacts.xlsx');
          });
        });
        e.cancel = true;
      }

    },
    setDeleteConfirmationMessage() {
      const dataGrid = this.$refs.dataGrid?.instance;
      dataGrid.option('editing', {
        allowUpdating: true,
        allowDeleting: true,
        mode: 'popup',
        texts: {
          confirmDeleteMessage: this.deleteConfirmationMessage,
          confirmDeleteTitle: "Confirmare Ștergere",
        }
      });
    },

  },
  mounted() {
    this.removeSearchTextFromStoredState("CrmActivitati");
    this.createODataContext();
    this.Username = JwtServices.GetUsername();
    this.dataGrid = this.$refs.dataGrid as DxDataGrid;
    this.setDeleteConfirmationMessage();
    loadMessages({
      "ro": {
        "Yes": "Da",
        "No": "Nu",
      }
    });

    locale('ro');
    this.$nextTick(() => {
      this.setDefaultDateRange();
      this.loadDashboardMetrics();
    });
  },
});
</script>
<style scoped lang="scss">
.activitati-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.grid-wrapper {
  flex: 1;
  min-height: 0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
}

.activitati-dashboard {
  margin-bottom: 16px;
  display: flex;
  gap: 16px;
  padding: 16px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
}

.metric-card {
  flex: 1;
  display: flex;
  align-items: center;
  padding: 16px 20px;
  background: white;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
}

.clickable-card {
  cursor: pointer;
  transition: all 0.2s ease;
  border: 2px solid transparent;
}

.clickable-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.active-filter {
  border-color: #3b82f6;
  background-color: #f8fafc;
}

.metric-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
}

.metric-icon i {
  font-size: 24px;
}

.metric-content {
  flex: 1;
}

.metric-label {
  font-size: 13px;
  color: #6b7280;
  margin-bottom: 4px;
  font-weight: 500;
}

.metric-value {
  font-size: 24px;
  font-weight: 700;
  color: #111827;
}

.overdue-text {
  color: #ef4444;
}

.tip-activitate-cell {
  display: flex;
  align-items: center;
  gap: 6px;
}

.tip-activitate-cell i {
  font-size: 16px;
  color: #6b6f76;
  opacity: 0.8;
}

.account-cell {
  display: flex;
  align-items: center;
  gap: 6px;
}

.account-cell .dx-icon-businesscenter,
.account-cell .dx-icon-home {
  font-size: 16px;
  color: #6b6f76;
}

.date-cell {
  display: flex;
  align-items: center;
  gap: 6px;
}

.date-cell .dx-icon-event {
  font-size: 16px;
  color: #6b6f76;
}

/* container toolbar date filter */
.date-filter-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  background: var(--dx-color-bg, #f8f9fa);
  border: 1px solid #dcdcdc;
  border-radius: 6px;
  height: 34px;
}

.date-filter-item .dx-texteditor {
  background-color: #ffffff !important;
}

.replace-actions {
  display: flex;
  justify-content: flex-end;
}

.date-filter-item .dx-datebox {
  width: 115px;
  min-width: 115px;
  height: 32px;
  border-bottom: none !important;
}

/* spațiere între itemii din toolbar */
.dx-toolbar .dx-toolbar-item {
  margin-right: 6px;
}


.link-oportunitate {
  color: #050505;
  text-decoration: none !important;
  cursor: pointer;
  font-weight: 500;
}

.link-oportunitate:hover {
  text-decoration: none;
}

.dx-datagrid-toolbar {
  padding: 6px 10px;
}


.dx-toolbar-items-container {
  align-items: center;
}

.activity-details-container {
  padding: 20px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #444;
  margin: 15px 0 10px 0;
  padding-bottom: 5px;
  border-bottom: 1px solid #eee;
}

.activity-info-item {
  display: flex;
  margin: 8px 0;
}

.info-label {
  font-weight: 600;
  color: #555;
  width: 100px;
}

.form-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
}

.info-value {
  color: #333;
  flex: 1;
}

.view-wrapper {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  flex-direction: row;

  .grid {
    .name-template {

      .position {
        font-size: 12px;
        color: var(--texteditor-label-color);
      }
    }

    :deep(.dx-datagrid-header-panel) {
      padding: 0 var(--content-padding);

    }

    :deep(.dx-datagrid-content .dx-row) {
      cursor: pointer;
    }


  }
}

.edit-cell {
  position: relative;

  activity-status {
    position: absolute;
    margin-top: 10px;
    margin-left: 11px;
  }
}

.sale-cell {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

.sale-cell i {
  font-size: 16px;
  color: #6b6f76;
  opacity: 0.85;
}

/* hover subtil */
.sale-cell:hover span {
  color: #0078d4;
}

.descriere-cell {
  display: flex;
  align-items: center;
  gap: 6px;
}

.descriere-cell i {
  font-size: 16px;
  color: #6b6f76;
  opacity: 0.8;
}

/* --- New Popup Styles --- */

.details-scroll-view {
  background-color: #f8f9fc;
}

.details-container {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Header Context */
.popup-header--activity {
  background: linear-gradient(90deg, #ff2c21, #ff6a4a);
}

/* Stats Row */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.stat-card {
  background: white;
  padding: 16px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
  transition: transform 0.2s, box-shadow 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  }
}

.stat-icon {
  font-size: 24px;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #f1f5f9;
  color: #475569;
}

.stat-card--cost .stat-icon {
  background: #ecfdf5;
  color: #059669;
}

.stat-card--cost .stat-value {
  color: #059669;
}

.stat-card--duration .stat-icon {
  background: #eff6ff;
  color: #2563eb;
}

.stat-card--date .stat-icon {
  background: #fdf2f8;
  color: #db2777;
}


.footer-right .dx-button {
  margin-left: 8px;
}

.footer-left .dx-button {
  margin-right: 8px;
}

.stat-content {
  flex: 1;
}

.stat-label {
  font-size: 11px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.025em;
  font-weight: 600;
}

.stat-value {
  font-size: 17px;
  font-weight: 700;
  color: #1e293b;
  margin-top: 2px;
}

/* Info Sections */
.info-sections-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.info-column {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.info-section-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.section-header {
  padding: 14px 16px;
  background: #fcfcfd;
  border-bottom: 1px solid #f1f5f9;
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 700;
  color: #334155;
  font-size: 14px;
}

.section-icon {
  color: #64748b;
  font-size: 18px;
}

.info-list {
  padding: 8px 0;
}

.info-item {
  padding: 10px 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;

  label {
    font-size: 11px;
    color: #94a3b8;
    text-transform: uppercase;
    font-weight: 600;
  }

  .value {
    font-size: 14px;
    color: #334155;
    font-weight: 500;

    &.multiline {
      line-height: 1.5;
      font-style: italic;
      color: #475569;
    }

    &.highlight {
      color: #2563eb;
    }

    &.success {
      color: #059669;
    }

    &.path-text {
      font-family: monospace;
      font-size: 12px;
      color: #64748b;
      word-break: break-all;
    }
  }
}


.files-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
}

.file-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #fff;
}

.file-name {
  font-size: 13px;
  color: #334155;
  max-width: 420px;

  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-actions {
  display: flex;
  gap: 6px;
}


.replace-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

/* Status Chips */
.status-chip {
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);

  &--global {
    background: #fef3c7;
    color: #92400e;
    border-color: #fcd34d;
  }

  &--local {
    background: #f1f5f9;
    color: #475569;
    border-color: #cbd5e1;
  }
}

/* Metadata */
.system-meta-card {
  background: #f1f5f9;
  border-radius: 10px;
  padding: 12px 20px;
}

.meta-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #64748b;
}

.meta-icon {
  font-size: 14px;
}

/* Base popup styles restored */
.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 18px;
  background: linear-gradient(90deg, #ff2c21, #ff6a4a);
  color: #fff;
}

.popup-header-main {
  display: flex;
  align-items: center;
  gap: 10px;
}

.popup-header-icon {
  font-size: 20px;
}

.popup-header-texts {
  display: flex;
  flex-direction: column;
}

.popup-header-title {
  font-size: 15px;
  font-weight: 700;
}

.popup-header-subtitle {
  font-size: 12px;
  opacity: 0.85;
}

.popup-header-meta {
  display: flex;
  align-items: center;
}

.replace-new {
  font-size: 13px;
  font-weight: 600;
  color: #059669;
}

.replace-none {
  font-size: 12px;
  color: #94a3b8;
}

.replace-block {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.replace-hint {
  font-size: 12px;
  color: #64748b;
}

.footer-fixed {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  border-top: 1px solid #e5e7eb;
  z-index: 1000;
}

.footer-right .dx-button {
  margin-left: 8px;
}

.popup-body-simple {
  background: white;
  padding: 20px;
}

.popup-body-modern {
  padding: 14px 18px 56px 18px;
}


.edit-file-card {
  width: 100%;
  box-sizing: border-box;
}


.edit-file-title {
  font-weight: 700;
  margin-bottom: 8px;
  color: #334155;
}

.edit-file-muted {
  color: #64748b;
  font-size: 13px;
}

.edit-file-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}

.edit-file-name {
  flex: 1;
  max-width: 620px;

  text-overflow: ellipsis;
  white-space: nowrap;
}

.edit-file-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
</style>